import { render, staticRenderFns } from "./form.vue?vue&type=template&id=cfa0d38a&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=cfa0d38a&prod&scoped=true&lang=css"
import style1 from "./form.vue?vue&type=style&index=1&id=cfa0d38a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa0d38a",
  null
  
)

export default component.exports